export default "__VITE_ASSET__B0Fkxx25__"